/*
 * @Description:
 * @Date: 2021-08-27 10:25:56
 * @LastEditTime: 2022-05-09 18:59:01
 * @FilePath: /vue-mall/src/vant-ui/index.js
 */
import Vue from 'vue';
import {
  AddressEdit,
  AddressList,
  Empty,
  Badge,
  Button,
  Checkbox,
  CheckboxGroup,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Icon,
  ImagePreview,
  Lazyload,
  Loading,
  Overlay,
  Popup,
  Stepper,
  SubmitBar,
  Swipe,
  SwipeItem,
  Tag,
  Toast,
  Skeleton,
  Divider,
  Rate,
  Tabbar,
  TabbarItem,
  SwipeCell,
  Field,
  Form,
  CellGroup,
  Radio,
  RadioGroup,
  Sticky,
  Calendar,
  // Area,
  // Card,
  // Cell,
  // Circle,
  // Col,
  // Collapse,
  // CollapseItem,
  // ContactCard,
  // ContactEdit,
  // ContactList,
  // Coupon,
  // CouponCell,
  // CouponList,
  // DatetimePicker,
  Dialog,
  // Info,
  // List,
  // Locale,
  // NavBar,
  // NoticeBar,
  // Notify,
  // NumberKeyboard,
  // Pagination,
  // Panel,
  // PasswordInput,
  // Picker,
  // Progress,
  // PullRefresh,
  // Row,
  // Search,
  Sku,
  // Slider,
  Step,
  Steps,
  Switch,
  // SwitchCell,
  // Tab,
  // Tabs,
  // TreeSelect,
  Uploader,
} from 'vant';

Vue.use(AddressEdit);
Vue.use(AddressList);
Vue.use(Empty);
Vue.use(Badge);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(GoodsAction);
Vue.use(GoodsActionIcon);
Vue.use(GoodsActionButton);
Vue.use(Icon);
Vue.use(ImagePreview);
Vue.use(Lazyload);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Popup);
Vue.use(Stepper);
Vue.use(SubmitBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tag);
Vue.use(Toast);
Vue.use(Skeleton);
Vue.use(Divider);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Rate);
Vue.use(SwipeCell);
Vue.use(Field);
Vue.use(Form);
Vue.use(CellGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Sticky);
Vue.use(Calendar);

// Vue.use(Area);
// Vue.use(Card);
// Vue.use(Cell);
// Vue.use(Circle);
// Vue.use(Col);
// Vue.use(Collapse);
// Vue.use(CollapseItem);
// Vue.use(ContactCard);
// Vue.use(ContactEdit);
// Vue.use(ContactList);
// Vue.use(Coupon);
// Vue.use(CouponCell);
// Vue.use(CouponList);
// Vue.use(DatetimePicker);
Vue.use(Dialog);
// Vue.use(Info);
// Vue.use(List);
// Vue.use(Locale);
// Vue.use(NavBar);
// Vue.use(NoticeBar);
// Vue.use(Notify);
// Vue.use(NumberKeyboard);
// Vue.use(Pagination);
// Vue.use(Panel);
// Vue.use(PasswordInput);
// Vue.use(Picker);
// Vue.use(Progress);
// Vue.use(PullRefresh);
// Vue.use(Row);
// Vue.use(Search);
Vue.use(Sku);
// Vue.use(Slider);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Switch);
// Vue.use(SwitchCell);
// Vue.use(Tab);
// Vue.use(Tabs);
// Vue.use(TreeSelect);
Vue.use(Uploader);
